export class CompactAddressModel {
    addressId: string;

    addressLine1: string;

    addressLine2: string;

    addressLine3: string;

    city: string;

    country: string;

    countryCode: string;

    countryZip: string;

    resState: string;

    state: string;

    streetName: string;

    zip: string;
}
